@if (this.teilaufgabenService.selectedTeilaufgabe) {
<p-dialog
  header="Teilaufgabe bearbeiten"
  [modal]="true"
  [visible]="this.visible"
  [closable]="false"
  [draggable]="false"
  [footerTemplate]="editTeilaufgabeFooter"
  position="top"
  [style]="{ width: '75rem' }"
>
  <div>
    <p-tabs value="0">
      <p-tablist>
        <p-tab value="0">Aufgabenstellung, Punktezahl, Antwortmöglichkeiten & Musterlösung</p-tab>
        <p-tab value="1">KI Korrektur Prompts & KI Korrektur testen</p-tab>
      </p-tablist>
      <p-tabpanels>
        <p-tabpanel value="0">
          <h3>Aufgabenstellung</h3>
          <app-reduced-editor
            class="mt-3"
            [(model)]="this.teilaufgabenService.selectedTeilaufgabe.aufgabenstellung"
            [disabled]="this.fallaufgabenService.selectedFallaufgabe.state === 'archived'"
          ></app-reduced-editor>
          <div class="flex flex-row">
            <div class="grow">
              <h3 class="mt-3">Maximal erreichbare Punktzahl</h3>
              <p-inputnumber
                class="mt-3"
                [(ngModel)]="this.teilaufgabenService.selectedTeilaufgabe.maxScore"
                [showButtons]="true"
                [step]=".5"
                [min]=".5"
                [disabled]="this.fallaufgabenService.selectedFallaufgabe.state === 'archived'"
                buttonLayout="horizontal"
                inputId="horizontal"
                spinnerMode="horizontal"
                mode="decimal"
                [minFractionDigits]="2"
              >
                <ng-template #incrementbuttonicon>
                  <span class="pi pi-plus"></span>
                </ng-template>
                <ng-template #decrementbuttonicon>
                  <span class="pi pi-minus"></span>
                </ng-template>
              </p-inputnumber>
            </div>
            @if (this.teilaufgabenService.selectedTeilaufgabe.type === 'standard') {
            <div class="ms-3 grow">
              <h3 class="mt-3">Antwortmöglichkeiten</h3>
              <p-inputnumber
                class="mt-3"
                [(ngModel)]="this.teilaufgabenService.selectedTeilaufgabe.answersCount"
                [showButtons]="true"
                [step]="1"
                [min]="1"
                [disabled]="this.fallaufgabenService.selectedFallaufgabe.state === 'archived'"
                buttonLayout="horizontal"
                inputId="horizontal"
                spinnerMode="horizontal"
                mode="decimal"
              >
                <ng-template #incrementbuttonicon>
                  <span class="pi pi-plus"></span>
                </ng-template>
                <ng-template #decrementbuttonicon>
                  <span class="pi pi-minus"></span>
                </ng-template>
              </p-inputnumber>
            </div>
            }
            @else {
            <div class="grow">
              <h3 class="mt-3">Korrektureinstellung</h3>
              <p-selectbutton
                [(ngModel)]="this.teilaufgabenService.selectedTeilaufgabe.lineByLineCorrection"
                [options]="[{label: 'Pro Zeile am Zeilenende', value: true}, {label: 'In separater Tabelle', value: false}]"
                optionLabel="label"
                optionValue="value"
                [allowEmpty]="false"
                class="mt-3"
              />
            </div>
            }
          </div>
          <h3 class="mt-3">Verwandte Teilaufgaben fuer KI-Korrektur</h3>
          <p-multiselect
            class="mt-3 w-full"
            [options]="this.relatedTeilaufgabenOptions"
            [(ngModel)]="this.selectedRelatedTeilaufgaben"
            optionLabel="label"
            optionValue="value"
            placeholder="Teilaufgaben aus derselben Fallaufgabe waehlen"
            [showClear]="true"
            [filter]="true"
            appendTo="body"
            [scrollHeight]="'18rem'"
            [panelStyle]="{ 'max-width': 'min(90vw, 52rem)' }"
            [disabled]="this.fallaufgabenService.selectedFallaufgabe.state === 'archived'"
          ></p-multiselect>

          <h3 class="mt-3">Korrekturhinweise</h3>
          <app-reduced-editor
            class="mt-3"
            [(model)]="this.teilaufgabenService.selectedTeilaufgabe.korrekturhinweise"
            [disabled]="this.fallaufgabenService.selectedFallaufgabe.state === 'archived'"
          ></app-reduced-editor>
          @if (this.teilaufgabenService.selectedTeilaufgabe.type === 'standard') {
          <h3 class="mt-3">Mögliche Lösungen</h3>
          <p-table
            showGridlines
            [value]="this.teilaufgabenService.selectedTeilaufgabe.solutions"
            [tableStyle]="{ 'min-width': '50rem' }"
            class="mt-3"
          >
            <ng-template #header>
              <tr>
                <th class="w-[80%]">Lösung</th>
                <th class="w-[15%]">Punkte</th>
                <th class="w-[5%]"></th>
              </tr>
            </ng-template>
            <ng-template
              #body
              let-solution
              let-ri="rowIndex"
            >
              <tr>
                <td>
                  <app-reduced-editor
                    [(model)]="solution.text"
                    [disabled]="this.fallaufgabenService.selectedFallaufgabe.state === 'archived'"
                  ></app-reduced-editor>
                </td>
                <td
                  [pEditableColumn]="solution.points"
                  pEditableColumnField="solution.points"
                >
                  <p-cellEditor>
                    <ng-template #input>
                      <p-inputnumber
                        [(ngModel)]="solution.points"
                        [showButtons]="true"
                        [step]=".5"
                        [max]="this.teilaufgabenService.selectedTeilaufgabe.maxScore"
                        [min]="0"
                        [disabled]="this.fallaufgabenService.selectedFallaufgabe.state === 'archived'"
                        buttonLayout="horizontal"
                        inputId="horizontal"
                        spinnerMode="horizontal"
                        mode="decimal"
                        [minFractionDigits]="2"
                        fluid
                      >
                        <ng-template #incrementbuttonicon>
                          <span class="pi pi-plus"></span>
                        </ng-template>
                        <ng-template #decrementbuttonicon>
                          <span class="pi pi-minus"></span>
                        </ng-template>
                      </p-inputnumber>
                    </ng-template>
                    <ng-template #output>
                      {{ solution.points }}
                    </ng-template>
                  </p-cellEditor>
                </td>
                <td>
                  <i
                    class="pi pi-trash"
                    pTooltip="Löschen"
                    tooltipPosition="top"
                    [ngClass]="{ 'cursor-pointer': this.fallaufgabenService.selectedFallaufgabe.state === 'draft'}"
                    style="color: var(--p-red-500)"
                    (click)="this.deleteSolution(ri)"
                  ></i>
                </td>
              </tr>
            </ng-template>
            <ng-template #footer>
              <tr>
                <td colspan="3">
                  <p-button
                    icon="pi pi-plus"
                    severity="secondary"
                    label="Lösung"
                    (onClick)="this.addEmptySolution()"
                    [disabled]="this.fallaufgabenService.selectedFallaufgabe.state !== 'draft'"
                  ></p-button>
                </td>
              </tr>
            </ng-template>
          </p-table>
          }
          @else {
          <h3 class="mt-3">Tabelle definieren</h3>
          <div class="flex items-center">
            <div class="flex-1">
              <p-table
                class="mt-3"
                [value]="this.teilaufgabenService.selectedTeilaufgabe.table"
                [tableStyle]="{ 'min-width': '50rem' }"
                tableStyleClass="specialTable"
              >
                <ng-template
                  #body
                  let-data
                  let-ri="rowIndex"
                >
                  <tr>
                    @for (entry of data; track $index) {
                    @if (entry.isEditable) {
                    <td
                      [pEditableColumn]="entry.solution"
                      pEditableColumnField="entry.solution"
                      (contextmenu)="this.onContextMenuTable($event, ri, entry)"
                      [ngClass]="{'text-primary': entry.isEditable}"
                      style="text-align: center !important;"
                      class="relative"
                    >
                      <p-cellEditor>
                        <ng-template #input>
                          <textarea
                            rows="1"
                            cols="10"
                            pTextarea
                            [(ngModel)]="entry.solution"
                            fluid
                          ></textarea>
                        </ng-template>
                        <ng-template #output>
                          {{ entry.solution }}
                          <i
                            class="pi pi-pencil absolute top-1 right-1"
                            style="font-size: 7pt;"
                          ></i>
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    }
                    @else {
                    <td
                      pEditableColumnField="entry.value"
                      [ngClass]="{'bg-gray-100': entry.isHeader, 'font-bold': entry.isHeader}"
                      [pEditableColumn]="entry.value"
                      (contextmenu)="this.onContextMenuTable($event, ri, entry)"
                      style="text-align: center !important;"
                    >
                      <p-cellEditor>
                        <ng-template #input>
                          <textarea
                            rows="1"
                            cols="10"
                            pTextarea
                            [(ngModel)]="entry.value"
                            fluid
                          ></textarea>
                        </ng-template>
                        <ng-template #output>
                          <span class="whitespace-pre">{{ entry.value }}</span>
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    }
                    }
                  </tr>
                </ng-template>
              </p-table>
            </div>
            <div class="flex-none w-[41px] ms-2">
              <p-button
                icon="pi pi-plus"
                severity="secondary"
                (onClick)="this.addColumnToTable()"
                [disabled]="this.fallaufgabenService.selectedFallaufgabe.state !== 'draft'"
              ></p-button>
            </div>
          </div>
          <div class="mt-2 text-center">
            <p-button
              icon="pi pi-plus"
              severity="secondary"
              (onClick)="this.addRowToTable()"
              [disabled]="this.fallaufgabenService.selectedFallaufgabe.state !== 'draft'"
            ></p-button>
          </div>
          <p-contextmenu
            [model]="this.context"
            (onHide)="this.onContextMenuTableHide()"
            appendTo="body"
            #cmTable
          >
            <ng-template
              #item
              let-item
            >
              <a
                pRipple
                class="flex items-center p-contextmenu-item-link"
              >
                <span
                  [class]="item.icon"
                  style="width: 19px;"
                ></span>
                <span class="ml-2">
                  @if (this.selectedEntry) {
                  @if (item.label === 'Editierbar') {
                  @if(!this.selectedEntry.isEditable) {
                  <i class="ri-checkbox-blank-line"></i>
                  }
                  @else {
                  <i class="ri-checkbox-line"></i>
                  }
                  }
                  @else if(item.label === 'Überschrift') {
                  @if(!this.selectedEntry.isHeader) {
                  <i class="ri-checkbox-blank-line"></i>
                  }
                  @else {
                  <i class="ri-checkbox-line"></i>
                  }
                  }
                  }
                  {{ item.label }}
                </span>
              </a>
            </ng-template>
          </p-contextmenu>
          }

        </p-tabpanel>
        <p-tabpanel value="1">
          <h3 class="mt-3">KI Korrektur Prompts</h3>
          <p-table
            showGridlines
            [value]="this.teilaufgabenService.selectedTeilaufgabe.aiSystemPromts"
            [tableStyle]="{ 'min-width': '50rem' }"
            class="mt-3"
          >
            <ng-template #header>
              <tr>
                <th class="w-[20%]">Name</th>
                <th class="w-[70%]">KI Korrektur Prompt</th>
                <th class="w-[10%]"></th>
              </tr>
            </ng-template>
            <ng-template
              #body
              let-prompt
              let-ri="rowIndex"
            >
              <tr [ngClass]="{ 'bg-gray-100 opacity-60': !this.isPromptEditable(prompt) }">
                <td>
                  @if (this.isPromptEditable(prompt) && this.isEditingPrompt(prompt)) {
                  <input
                    pInputText
                    type="text"
                    [(ngModel)]="this.promptTemplatesMap.get(prompt)!.name"
                    class="w-full"
                  />
                  }
                  @else {
                  <span class="font-semibold">
                    {{ this.promptTemplatesMap.get(prompt)?.name || 'Unbekannt' }}
                  </span>
                  }
                </td>
                <td>
                  @if (this.isPromptEditable(prompt) && this.isEditingPrompt(prompt)) {
                  <textarea
                    rows="3"
                    cols="30"
                    pTextarea
                    [(ngModel)]="this.promptTemplatesMap.get(prompt)!.prompt"
                    fluid
                  ></textarea>
                  }
                  @else {
                  {{ getPromptText(prompt) | shorty: 150 }}
                  }
                </td>
                <td>
                  <div class="flex gap-2 justify-end">
                    @if (this.isPromptEditable(prompt)) {
                    @if (this.isEditingPrompt(prompt)) {
                    <i
                      class="pi pi-check cursor-pointer"
                      pTooltip="Speichern"
                      tooltipPosition="top"
                      style="color: var(--p-green-500)"
                      (click)="this.updatePromptTemplate(prompt)"
                    ></i>
                    <i
                      class="pi pi-times cursor-pointer"
                      pTooltip="Abbrechen"
                      tooltipPosition="top"
                      style="color: var(--p-orange-500)"
                      (click)="this.toggleEditMode(prompt)"
                    ></i>
                    }
                    @else {
                    <i
                      class="pi pi-pencil cursor-pointer"
                      pTooltip="Bearbeiten"
                      tooltipPosition="top"
                      style="color: var(--p-blue-500)"
                      (click)="this.toggleEditMode(prompt)"
                    ></i>
                    }
                    }
                    <i
                      class="pi pi-trash cursor-pointer"
                      pTooltip="Löschen"
                      tooltipPosition="top"
                      style="color: var(--p-red-500)"
                      (click)="this.deletePrompt(ri)"
                    ></i>
                  </div>
                </td>
              </tr>
            </ng-template>
            <ng-template #footer>
              <tr>
                <td colspan="3">
                  <div class="flex gap-2 items-center">
                    <p-select
                      [(ngModel)]="this.selectedPromptId"
                      [options]="this.filteredPromptTemplates"
                      optionLabel="name"
                      optionValue="_id"
                      placeholder="KI Korrektur Prompt auswählen"
                      [style]="{'min-width': '300px'}"
                      [disabled]="this.fallaufgabenService.selectedFallaufgabe.state !== 'draft'"
                      appendTo="body"
                    />
                    <p-button
                      icon="pi pi-plus"
                      severity="secondary"
                      label="Aus Auswahl hinzufügen"
                      (onClick)="this.addPromptFromSelection()"
                      [disabled]="this.fallaufgabenService.selectedFallaufgabe.state !== 'draft' || !this.selectedPromptId"
                    ></p-button>
                    <p-button
                      icon="pi pi-plus"
                      severity="success"
                      label="Neuen Prompt erstellen"
                      (onClick)="this.addNewAiSystemPrompt()"
                      [disabled]="this.fallaufgabenService.selectedFallaufgabe.state !== 'draft'"
                    ></p-button>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>

          <!-- KI Test Section -->
          <h3 class="mt-3">KI-Bewertung testen</h3>

          <!-- Antwortsets -->
          <div class="mt-3 flex items-center gap-2">
            <p-select
              [(ngModel)]="this.selectedAntwortSetIndex"
              [options]="this.antwortSetOptions"
              optionLabel="label"
              optionValue="value"
              placeholder="Antwortset auswählen..."
              [style]="{'min-width': '250px'}"
              appendTo="body"
              [showClear]="true"
            ></p-select>
            <p-button
              icon="pi pi-check"
              severity="info"
              label="Aktivieren"
              [outlined]="true"
              (onClick)="loadAntwortSet()"
              [disabled]="this.selectedAntwortSetIndex == null"
              pTooltip="Antwortset in Testfelder aktivieren"
              tooltipPosition="top"
            ></p-button>
            <p-button
              icon="pi pi-sync"
              severity="warn"
              label="Überschreiben"
              [outlined]="true"
              (onClick)="overwriteAntwortSet()"
              [disabled]="this.selectedAntwortSetIndex == null"
              pTooltip="Ausgewähltes Antwortset mit aktuellen Antworten überschreiben"
              tooltipPosition="top"
            ></p-button>
            <p-button
              icon="pi pi-trash"
              severity="danger"
              [outlined]="true"
              (onClick)="deleteAntwortSet()"
              [disabled]="this.selectedAntwortSetIndex == null"
              pTooltip="Antwortset löschen"
              tooltipPosition="top"
            ></p-button>
            <div class="ms-auto flex items-center gap-2">
              <input
                pInputText
                type="text"
                [(ngModel)]="this.newAntwortSetName"
                placeholder="Name für neues Antwortset"
                class="w-64"
              />
              <p-button
                icon="pi pi-save"
                severity="success"
                label="Antwortset speichern"
                (onClick)="saveAntwortSet()"
                pTooltip="Aktuelle Testantworten als neues Antwortset speichern"
                tooltipPosition="top"
              ></p-button>
            </div>
          </div>

          <div class="ki-test-section mt-3">
            <div class="flex flex-column gap-2">
              @if (this.teilaufgabenService.selectedTeilaufgabe.type === 'table') {
              <app-table
                [table]="this.teilaufgabenService.selectedTeilaufgabe.table"
                #testTable
              ></app-table>
              }
              @else {
              <h4 class="m-0 mb-2">Testantworten für diese Teilaufgabe</h4>
              @for (answer of testUserAnswers; track $index) {
              <div class="main-answer-field">
                <label class="font-semibold">Antwort {{ $index + 1 }}:</label>
                <textarea
                  rows="2"
                  pTextarea
                  [(ngModel)]="testUserAnswers[$index]"
                  placeholder="Nutzerantwort eingeben..."
                  class="w-full"
                ></textarea>
                @if (testUserAnswers.length > 1) {
                <div class="flex justify-end">
                  <i
                    class="pi pi-trash cursor-pointer"
                    style="color: var(--p-red-500)"
                    pTooltip="Antwort entfernen"
                    tooltipPosition="top"
                    (click)="removeTestAnswer($index)"
                  ></i>
                </div>
                }
              </div>
              }
              <div class="flex gap-2 mt-1">
                <p-button
                  icon="pi pi-plus"
                  severity="secondary"
                  label="Antwort hinzufügen"
                  [outlined]="true"
                  (onClick)="addTestAnswer()"
                ></p-button>
              </div>
              }

              @if (this.selectedRelatedTeilaufgabenForTest.length > 0) {
              <div class="mt-3 p-3 border rounded related-test-section">
                <h4 class="m-0 mb-1">Testantworten für verknüpfte Teilaufgaben</h4>
                <p class="m-0 mb-3 text-sm related-test-hint">
                  Jede verknüpfte Teilaufgabe kann einzeln aufgeklappt und bearbeitet werden.
                </p>
                <div class="related-answers-list">
                  @for (related of this.selectedRelatedTeilaufgabenForTest; track related._id) {
                  <details class="related-answer-item" [open]="$first">
                    <summary class="related-answer-summary">
                      <span class="related-answer-title">{{ this.getRelatedTitle(related) }}</span>
                      <span class="related-answer-type">{{ related.type === 'table' ? 'Tabelle' : 'Standard' }}</span>
                    </summary>
                    <div class="related-answer-content">
                    @if (related.type === 'standard') {
                    @for (answer of this.getRelatedStandardAnswers(related._id); track $index) {
                    <div class="related-answer-field">
                      <label class="font-semibold">Antwort {{ $index + 1 }}:</label>
                      <textarea
                        rows="2"
                        pTextarea
                        [(ngModel)]="this.getRelatedStandardAnswers(related._id)[$index]"
                        placeholder="Nutzerantwort für related Teilaufgabe"
                        class="w-full"
                      ></textarea>
                    </div>
                    }
                    }
                    @else {
                    <div class="related-table-wrap">
                      <table class="w-full border-collapse related-table">
                        @for (row of related.table; track $index; let rowIndex = $index) {
                        <tr>
                          @for (cell of row; track $index; let colIndex = $index) {
                          <td class="border p-1">
                            @if (cell.isEditable) {
                            <textarea
                              rows="2"
                              pTextarea
                              [(ngModel)]="this.getRelatedTableAnswers(related._id)[rowIndex][colIndex]"
                              placeholder="Zellantwort"
                              class="w-full related-table-cell-input"
                            ></textarea>
                            }
                            @else {
                            <span class="text-sm">{{ cell.value }}</span>
                            }
                          </td>
                          }
                        </tr>
                        }
                      </table>
                    </div>
                    }
                    </div>
                  </details>
                  }
                </div>
              </div>
              }

              <div class="flex gap-2 mt-1">
                <p-button
                  icon="pi pi-play"
                  severity="info"
                  label="KI testen"
                  (onClick)="testKiResult()"
                  [loading]="testLoading"
                  [disabled]="testLoading"
                ></p-button>
              </div>
            </div>

            @if (testLoading) {
            <p-progressbar
              mode="indeterminate"
              [style]="{ height: '6px' }"
              class="mt-3"
            ></p-progressbar>
            }

            @if (testResult) {
            <div class="ki-test-result mt-3">
              <div class="flex flex-column gap-2">
                <div>
                  <span class="font-semibold">Punktzahl:</span>
                  <span class="ms-2">{{ testResult.kiScore }}</span>
                </div>
                <div>
                  <span class="font-semibold">Kommentar:</span>
                  <div class="mt-1 ki-result-box">{{ testResult.kiComment }}</div>
                </div>
                <div>
                  <span class="font-semibold">Begründung:</span>
                  <div class="mt-1 ki-result-box">{{ testResult.kiReasoning }}</div>
                </div>
              </div>
            </div>
            }

            @if (testTableResult && this.teilaufgabenService.selectedTeilaufgabe.type === 'table') {
            <app-ki-result-table
              class="mt-3"
              [table]="this.teilaufgabenService.selectedTeilaufgabe.table"
              [userAnswers]="lastTestAnswers"
              [kiTable]="testTableResult.kiTable"
              [kiReasoning]="testTableResult.kiReasoning"
            ></app-ki-result-table>
            }

            @if (testPromptMessages && testPromptMessages.length > 0) {
            <details class="mt-3">
              <summary class="prompt-msg-summary">
                <i class="pi pi-envelope me-2"></i>
                Abgesendete Prompt-Nachrichten ({{ testPromptMessages.length }})
              </summary>
              <div class="prompt-msg-list mt-2">
                @for (msg of testPromptMessages; track $index) {
                <div class="prompt-msg-block prompt-msg--{{ msg.role }}">
                  <span class="prompt-msg-role">{{ msg.role }}</span>
                  <pre class="prompt-msg-content">{{ msg.content }}</pre>
                </div>
                }
              </div>
            </details>
            }
          </div>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
  </div>
  <ng-template #editTeilaufgabeFooter>
    <div class="flex justify-end gap-2 mt-2">
      <p-button
        label="Abbrechen"
        severity="secondary"
        (click)="this.close()"
      />
      <p-button
        label="Speichern"
        severity="success"
        (click)="this.save()"
      />
    </div>
  </ng-template>
</p-dialog>
}